export default (client) => {
  return {
    get(slug) {
      return client.get(`/saas/user-docs/${slug}`)
    },
  }
}
